import {
  bankNameSearchApi,
  postSearchApi,
  positionSearchApi,
  rankSearchApi,
  scheduleSearchApi,
  regularSearchApi,
  contractsSearchApi
} from './services'
import { SelectSearchEnum } from './type'

export const NoInitType: string[] = ['changed_value']

export const SearchSelectApi: Record<string, Function> = {
  [SelectSearchEnum.Post]: postSearchApi,
  [SelectSearchEnum.Position]: positionSearchApi,
  [SelectSearchEnum.Rank]: rankSearchApi,
  [SelectSearchEnum.Schedule]: scheduleSearchApi,
  [SelectSearchEnum.Regular]: regularSearchApi,
  [SelectSearchEnum.BankName]: bankNameSearchApi,
  [SelectSearchEnum.Contracts]: contractsSearchApi
}
